(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TeamManagementDialogController', TeamManagementDialogController);

    TeamManagementDialogController.$inject = ['$state', 'entity', 'Team', 'JhiLanguageService', 'UserProfile', 'domain'];

    function TeamManagementDialogController($state, entity, Team, JhiLanguageService, UserProfile, domain) {
        var vm = this;

        vm.authorities = null;
        vm.languages = null;
        vm.userProfiles = null;
        vm.save = save;
        vm.user = entity;
        vm.domain = domain;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        UserProfile.getTeamProfiles().$promise.then(function (userProfiles) {
            $('#login').prop('readonly', true);
            vm.userProfiles = userProfiles;
        });

        function onSaveSuccess(result) {
            vm.isSaving = false;
            $state.go('team-management');
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.clear = function () {
            $state.go('team-management');
        };

        function save() {
            vm.isSaving = true;
            vm.user.authorities = [vm.user.authorities];
            Team.update(vm.user, onSaveSuccess, onSaveError);
        }
    }
})();
